export const renderAccent = (text, accentClass = "italic text-gold-dark") => {
  if (typeof text !== "string") return text;
  const parts = text.split("*");
  if (parts.length === 1) return text;
  return parts.map((part, i) =>
    i % 2 === 1 ? (
      <span key={i} className={accentClass}>
        {part}
      </span>
    ) : (
      part
    )
  );
};
